import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';

export class BankAccountTransactionSourceGroupForm extends CerFormAdapter {
  
  public override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'bank-transaktion-kilde-gruppe', dataApiName: 'BankAccountTransactionSourceGroup', text: 'Grupper',
        primaryKey: 'id', allowEdit: false, allowCreate: false, allowDelete: false, baseFields: ['id', 'history']
      },
      fieldMetadata:
        [
          { name: 'name', text: 'Gruppenavn' },
          { name: 'sumOrder', text: 'Sortering', format: 'Integer', orderBy: 'Ascending' }
        ]
    });
  }

}
